























import { SubscribedPaidMembershipPlan } from '@/models/api/paid-member-price/member-plan/available-membership-plan'
import WillUnsubscribe from '@spa/components/pages/paid-membership/unsubscribe/atom/WillUnsubscribe.vue'
import BaseState from '@spa/components/pages/paid-membership/unsubscribe/state/BaseState.vue'
import Vue from 'vue'
import { Component, Emit, Prop } from 'vue-property-decorator'
@Component({
  components: { BaseState, WillUnsubscribe },
})
export default class Subscribed extends Vue {
  @Prop({ required: true })
  readonly plan: SubscribedPaidMembershipPlan

  @Emit('unsubscribe')
  emitUnsubscribe() {
    return this.plan
  }
}
